/** */
import { apiGet, apiPost } from 'services/_http';
import { urls } from 'services/_url';

/** */
const base_url = `${urls.sales}/invoices`;

export const generate = async (options = {}) => {
  return await apiPost(base_url, { ...options });
};

export const read = async (options = {}) => {
  return await apiGet(base_url, { ...options });
};
